import Head from "next/head";
import { generateNextSeo } from "next-seo/pages";
import { buildCanonicalUrl } from "lib/seo";

import ErrorBoundary from "components/errorBoundary/errorBoundary";
import Navigation from "components/navigation/navigation";
import Footer from "components/footer/footer";
import { fetchNavbarAndFooter } from "lib/fetchers/common";
import {
  fetchIntelligencePageData,
  fetchReportsPageData,
  ReportsPageData,
} from "content-ui/intelligence/fetcher";

import ReportsPageView from "content-ui/intelligence/reportsPageView";
import type { Report } from "content-ui/intelligence/types";

export async function getServerSideProps({ preview = false }) {
  const [menuItems, pageData, dato] = await Promise.all([
    fetchNavbarAndFooter(),
    fetchIntelligencePageData({ preview }),
    fetchReportsPageData({ preview }),
  ]);

  const featuredReport = pageData.reports[0];
  const reportsList = pageData.reports.slice(1);
  const featuredReportSubtitle = "Our latest report";

  return {
    props: {
      dato,
      featuredReport,
      featuredReportSubtitle,
      reportsList,
      __initialState: {
        sitewideOption: { ...menuItems },
      },
    },
  };
}

type ReportsPageProps = {
  dato: ReportsPageData;
  featuredReport: Report;
  featuredReportSubtitle: string;
  reportsList: Report[];
};

const ReportsPage = (props: ReportsPageProps) => {
  const title = "Reports | Sifted";
  const description =
    "Sifted Reports: trusted insight and analysis into Europe’s startup ecosystem.";
  const seoImage =
    "https://images.sifted.eu/wp-content/uploads/2022/05/09160131/ReportsThumbnail-scaled.jpeg?auto=format,compress&q=75&w=1200";

  return (
    <>
      <Head>
        {generateNextSeo({
          title: title,
          description: description,
          canonical: buildCanonicalUrl("/intelligence/reports"),
          openGraph: {
            title: title,
            description: description,
            images: [{ url: seoImage }],
          },
          twitter: {
            handle: "@siftedeu",
            site: "@siftedeu",
            cardType: "summary_large_image",
          },
        })}
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Navigation />
      <ErrorBoundary>
        <ReportsPageView {...props} />
      </ErrorBoundary>
      <Footer />
    </>
  );
};

export default ReportsPage;
